<div class="row bg-light">
    <div class="col">
        <h3>{{ teamName }} {{ name }}</h3>
    </div>
    <div class="col text-right">
        <span id="currentScore">{{ currentScore }}/{{ possibleScore }} PTS</span>
    </div>
</div>
